import { render, staticRenderFns } from "./MainItem.vue?vue&type=template&id=fc630e3e&scoped=true&"
import script from "./MainItem.vue?vue&type=script&lang=ts&"
export * from "./MainItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc630e3e",
  null
  
)

export default component.exports